import { DraftShareholder, IdentityType } from '@blockpulse3/graphql/hooks';

/**
 * shareholderTitle.
 * Function to return the "title" of the form.
 * For a legal one, it's the company name (.name) and firstName and lastName for a
 * natural one.
 *
 * @param {DraftShareholder} shareholder
 * @returns {string}
 */
export function shareholderTitle(shareholder: DraftShareholder): string {
  if (shareholder.type === IdentityType.COMPANY) {
    return shareholder.name || '';
  }
  return `${shareholder.firstName} ${shareholder.lastName}`;
}
